import { render, staticRenderFns } from "./SineWave.vue?vue&type=template&id=7ccf7c34&scoped=true&"
import script from "./SineWave.vue?vue&type=script&lang=js&"
export * from "./SineWave.vue?vue&type=script&lang=js&"
import style0 from "./SineWave.vue?vue&type=style&index=0&id=7ccf7c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf7c34",
  null
  
)

export default component.exports